var WDN = WDN || {};

if (typeof WDN.KlaviyoForm === "undefined") {
  WDN.KlaviyoForm = (function () {
    class NewsletterForm extends WDN.SimpleForm {
      constructor() {
        super();

        this.id = this.getAttribute("data-id");
        this.url = "https://manage.kmail-lists.com/ajax/subscriptions/subscribe";
        this.source = this.getAttribute("data-source");
        this.emailInput = this.querySelector("input[name='email']");

        this.attach();

        // Listen for email input
        this.emailInput.addEventListener("input", () => {
          // Remove input warning
          this.removeAttribute("data-input-warning", "");
        });
      }

      attach() {
        if (typeof KlaviyoSubscribe === "undefined") return;
        KlaviyoSubscribe.attachToForms("#" + this.id, {
          hide_form_on_success: true,
          success: function () {
            this.setAttribute("data-form-submitted");
          }.bind(this),
          extra_properties: {
            source: this.source,
          },
        });
      }

      setEmailValue(newEmailValue) {
        if (!newEmailValue) return;
        this.emailInput = this.querySelector("input[name='email']");
        this.emailInput.value = newEmailValue;
      }

      fireSuccessEvent() {
        this.dispatchEvent(
          new CustomEvent("simple-form:submit", {
            bubbles: true,
            detail: {},
          })
        );
      }

      onSubmitSuccess() {
        this.fireSuccessEvent();
        this.setAttribute("data-call-status", "complete");
      }
      onSubmitError() {
        this.setAttribute("data-call-status", "error");

        setTimeout(
          function () {
            this.removeAttribute("data-call-status");
          }.bind(this),
          2000
        );
      }

      onSubmit(e) {
        e ? e.preventDefault() : "";

        // Form data
        this.formData = new FormData(this.nodeForm.form);

        // Email regex
        var emailRegex = /\S+@\S+\.\S+/;

        // Test whether the input is correct
        if (!emailRegex.test(this.formData.get("email"))) {
          this.setAttribute("data-input-warning", "");
          return;
        }

        // Send request
        fetch(this.url, {
          headers: {
            accept: "application/json, text/plain, */*",
            "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
          },
          body: new URLSearchParams({
            g: this.formData.get("g"),
            email: this.formData.get("email"),
            $fields: this.formData.get("$fields"),
            $list_fields: this.formData.get("$list_fields"),
            $source: this.source,
          }),
          method: "POST",
        })
          .then((response) => {
            return response.json();
          })
          .then((response) => {
            if (response.success) {
              this.onSubmitSuccess();
            } else {
              this.onSubmitError();
            }
          })
          .catch((err) => {
            this.onSubmitError();
          });
      }
    }

    class BackInStockForm extends WDN.SimpleForm {
      constructor() {
        super();
        this.url = "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe";
      }

      fireSuccessEvent() {
        this.dispatchEvent(
          new CustomEvent("simple-form:submit", {
            detail: {},
          })
        );
      }

      onSubmitSuccess() {
        this.fireSuccessEvent();
        this.setAttribute("data-call-status", "complete");
      }

      onSubmitError() {
        this.setAttribute("data-call-status", "error");

        setTimeout(
          function () {
            this.removeAttribute("data-call-status");
          }.bind(this),
          2000
        );
      }

      onSubmit(e) {
        e ? e.preventDefault() : "";

        fetch(this.url, {
          headers: {
            accept: "application/json, text/plain, */*",
            "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
          },
          body: new URLSearchParams({
            a: this.formData.get("a"),
            email: this.formData.get("email"),
            phone_number: "+" + this.formData.get("phone_prefix") + this.formData.get("phone"),
            sms_consent: true,
            variant: this.formData.get("variant"),
            platform: "shopify",
          }),
          method: "POST",
        })
          .then((response) => {
            return response.json();
          })
          .then((response) => {
            if (response.success) {
              this.onSubmitSuccess();
            } else {
              this.onSubmitError();
            }
          })
          .catch((err) => {
            this.onSubmitError();
          });
      }
    }

    customElements.define("newsletter-form", NewsletterForm);
    customElements.define("stock-form", BackInStockForm);

    return {};
  })();
}
